export default "__VITE_ASSET__DP$pC8B8__"